




import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';
import moment from 'moment';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class BalanceChart extends Vue {
  @Prop() readonly series: any;

  @Prop() readonly title!: string;

  chartOptions: any = {
    tooltip: {
      useHTML: true,
      headerFormat: '',
      pointFormat: '<span style="color:{point.color}">●</span><b>{point.series.name} <b><br>Day{point.x:,.0f}<br>{point.y:,.2f}',
    },
    lang: {
      thousandsSep: ',',
      decimalPoint: ',',
    },
    title: {
      text: this.title,
    },
    subtitle: {
      text: `In ${moment().format('MMM, YYYY')}`,
    },
    yAxis: {
      title: {
        text: 'Amount',
      },
    },
    xAxis: {
      title: {
        text: `Date in ${moment().format('MMM, YYYY')}`,
      },
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        pointStart: 1,
      },
    },
  };

  created() {
    const { series } = this;
    this.chartOptions = { ...this.chartOptions, series };
  }
}
